const MARKER = 'is.authenticated'
const LEGACY_PREFIX = '_legacy_'

export const sessionHintCookieNames = (clientId: string): string[] => {
  const names = [`auth0.${MARKER}`]
  if (clientId !== '') names.push(`auth0.${clientId}.${MARKER}`)
  return names.flatMap((name) => [name, `${LEGACY_PREFIX}${name}`])
}

export const hasSessionHint = (cookieText: string, clientId: string): boolean => {
  const wanted = new Set(sessionHintCookieNames(clientId))
  return cookieText.split(';').some((part) => {
    const eq = part.indexOf('=')
    if (eq < 0) return false
    return wanted.has(part.slice(0, eq).trim()) && part.slice(eq + 1).trim() !== ''
  })
}

const readSessionHintAtLoad = (): boolean => {
  try {
    const clientId: unknown = import.meta.env.VITE_AUTH0_CLIENT_ID
    return hasSessionHint(globalThis.document.cookie, typeof clientId === 'string' ? clientId : '')
  } catch {
    return false
  }
}

export const SESSION_HINT_AT_LOAD: boolean = readSessionHintAtLoad()

export const resumesSignInAtRoot = ({
  hadSessionHint,
  signInFailed
}: {
  hadSessionHint: boolean
  signInFailed: boolean
}): boolean => hadSessionHint && !signInFailed
